import styled from 'styled-components';
import { fonts } from 'styles';

export const Container = styled.header`
  width: 100%;
  padding: 142px 32px;

  @media screen and (max-width: 960px) {
    padding: 72px 32px 32px 32px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  column-gap: 111px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Title = styled.h1`
  font-family: ${fonts.BentonSansCompressedBold};
  font-size: 139px;
  line-height: 119px;
  text-transform: uppercase;
  color: #f676e8;
  position: relative;

  @media screen and (max-width: 1024px) {
    font-size: 110px;
    line-height: 99px;
  }

  @media screen and (max-width: 960px) {
    width: 100%;
    margin-bottom: 48px;
  }

  @media screen and (max-width: 500px) {
    font-size: 56px;
    line-height: 50px;
  }
`;

export const Text = styled.article`
  width: 100%;
  max-width: 350px;
  font-family: ${fonts.BentonSansMedium};
  font-size: 18px;
  line-height: 26px;
  color: #fff;

  @media screen and (max-width: 960px) {
    max-width: 100%;
  }
`;

export const Credit = styled.div`
  width: 240px;
  padding-top: 24px;
  border-top: 2px solid #fff;
  position: absolute;
  bottom: -100px;
  text-transform: none !important;

  p {
    font-family: ${fonts.BentonSansRegular};
    font-size: 16px;
    line-height: 26px;
    color: #fff;
  }

  @media screen and (max-width: 960px) {
    position: relative;
    bottom: unset;
    margin-top: 24px;
    width: 100%;
  }
`;
